/**课程任务模块 */
import request from '../request/http';
/**分页查询我的学习任务 */
export function PageMyTaskList(data){
    return request({
        url: '/sp/courseTask/pageMyTaskList',
        method: 'post',
        data
    })
}
/**新增课程任务 */
export function AddCourseTask(data){
    return request({
        url: '/sp/courseTask/add',
        method: 'post',
        data
    })
}
/**删除课程任务 */
export function DelCourseTask(data){
    return request({
        url: '/sp/courseTask/del',
        method: 'post',
        data
    })
}
/**分页查询课程任务 */
export function PageTaskList(data){
    return request({
        url: '/sp/courseTask/pageList',
        method: 'post',
        data
    })
}
/**修改课程任务 */
export function UpdateCourseTask(data){
    return request({
        url: '/sp/courseTask/upd',
        method: 'post',
        data
    })
}